module.exports = __webpack_public_path__ + "img/version_max.50a5110c.png";